import type { Project } from '../../aansluiting/project/types/Project'
import type { PatchBijlageTemplatePayload } from '../services/patchBijlageTemplate'
import type { BijlageTemplate } from '../types/BijlageTemplate'

type ReferenceOption = { code: string; label: string }

// zie ook `bijlage-reference.js` in de API
export const referenceOptions = (
  projectType: Project['type'],
): ReferenceOption[] => {
  const base: ReferenceOption[] = [
    { code: 'aanvraagDatum', label: 'aanvraagdatum' },
    { code: 'dueWeek', label: 'opleverweek' },
    { code: 'creatieDatum', label: 'creatiedatum' },
  ]

  if (projectType === 'Hoofdleiding') {
    base.push({ code: 'startUitvoeringWeek', label: 'geplande uitvoering' })
  }

  if (projectType === 'Aanvraag') {
    base.push({
      code: 'geplandeUitvoeringsdatum',
      label: 'geplande uitvoering',
    })
  }

  return base
}

// zie ook `REFERENCES_ALLOWING_WAITFOR` in de API
export const REFERENCES_ALLOWING_WAITFOR = [
  'dueWeek',
  'startUitvoeringWeek',
  'geplandeUitvoeringsdatum',
]

export const hasBijlageTemplatePlanning = (
  bijlageTemplate: Pick<
    BijlageTemplate,
    'reference' | 'herplanDiff' | 'waitFor'
  >,
): boolean =>
  Boolean(
    bijlageTemplate.reference ||
    bijlageTemplate.herplanDiff ||
    bijlageTemplate.waitFor,
  )

export const getWaitForCandidates = (
  templateSet: BijlageTemplate[],
  self: BijlageTemplate,
): BijlageTemplate[] => templateSet.filter((t) => t._id !== self._id)

export const getInitialWaitForCandidate = (
  candidates: BijlageTemplate[],
  waitFor?: string,
): BijlageTemplate | null =>
  candidates.find((t) => t.documentsoort === waitFor) ?? null

export const getAvailableReferenceOptions = (
  waitForCandidate: BijlageTemplate | null,
  projectType: Project['type'],
): ReferenceOption[] =>
  waitForCandidate
    ? referenceOptions(projectType).filter((opt) =>
        REFERENCES_ALLOWING_WAITFOR.includes(opt.code),
      )
    : referenceOptions(projectType)

// Convert `null` in patch payload to `undefined` to match cached `BijlageTemplate`.
export const mergeBijlageTemplate = (
  cached: BijlageTemplate,
  patch: PatchBijlageTemplatePayload,
): BijlageTemplate => {
  if (cached.scope !== 'project') {
    return { ...cached, sortOrder: patch.sortOrder ?? cached.sortOrder }
  }

  const merged = { ...cached, ...patch }
  return {
    ...merged,
    reference: merged.reference ?? undefined,
    herplanDiff: merged.herplanDiff ?? undefined,
    waitFor: merged.waitFor ?? undefined,
  }
}

const assignedToLabels = {
  NB: 'Netbeheerders',
  AN: 'Aannemers',
  COORD: 'Coördinerende aannemer',
  COMBI: 'Combi',
  GEEN: 'Geen',
}

export const formatAssignedTo = (assignedTo: string | string[]) => {
  if (Array.isArray(assignedTo)) {
    return assignedTo.map((a) => assignedToLabels[a] || a).join(', ')
  }
  return assignedToLabels[assignedTo] || assignedTo
}
